module.exports = __webpack_public_path__ + "img/wide.cab75889.jpg";